import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 配置模块
 */
export const Deploy = {
    /**
     * site车间操作
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getSiteList(parmas, expend) { // 查询站点列表
        return send("GET", "/api/company/site/find", parmas, expend);
    },
    postSiteAdd(parmas, expend) { // 添加站点
        return send("POST", "/api/company/site/create", parmas, expend);
    },
    postSiteEdit(parmas, expend) { // 更新站点
        return send("POST", "/api/company/site/modify", parmas, expend);
    },
    getSiteDel(parmas, expend) { // 删除站点
        return send("GET", "/api/company/site/del", parmas, expend);
    },
    postSiteRole(parmas, expend) {
        return send("POST", "/api/company/site/modify/visibleUsers", parmas, expend)
    },
    /**
     * device设备操作
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getDeviceList(parmas, expend) { // 查询设备列表
        return send("GET", "/api/company/siteDevice/find", parmas, expend);
    },
    getDeviceList_1(parmas, expend) { // 查询设备管理列表
        return send("GET", "/api/company/siteDevice/find_1", parmas, expend);
    },
    postDeviceAdd(parmas, expend) { // 添加设备
        return send("POST", "/api/company/siteDevice/create", parmas, expend);
    },
    postDeviceEdit(parmas, expend) { // 更新设备
        return send("POST", "/api/company/siteDevice/modify", parmas, expend);
    },
    getDeviceDel(parmas, expend) { // 删除设备
        return send("GET", "/api/company/siteDevice/del", parmas, expend);
    },
    getDeviceTypeImage(parmas, expend) { // 获取站点设备类型对应图片
        return send("GET", "/api/company/siteDeviceImage/findAll", parmas, expend);
    },
    /**
     * rtu操作
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getRtuList(parmas, expend) { // 查询rtu列表
        return send("GET", "/api/company/rtu/find", parmas, expend);
    },
    postRtuAdd(parmas, expend) { // rtu添加
        return send("POST", "/api/company/rtu/create", parmas, expend);
    },
    postRtuEdit(parmas, expend) { // rtu更新
        return send("POST", "/api/company/rtu/modify", parmas, expend);
    },
    getRtuDel(parmas, expend) { // rtu删除
        return send("GET", "/api/company/rtu/del", parmas, expend);
    },
    getCheckCode(parmas, expend) { // 判断rtu的code是否重复
        return send("GET", "/api/common/rtu/checkCode", parmas, expend);
    },
    /**
     * 约束规则操作
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getConstraintList(parmas, expend) { // 查询约束规则列表
        return send("GET", "/api/company/flowConstraint/find", parmas, expend);
    },
    postConstraintAdd(parmas, expend) { // 约束规则添加
        return send("POST", "/api/company/flowConstraint/add", parmas, expend);
    },
    postConstraintEdit(parmas, expend) { // 约束规则更新
        return send("POST", "/api/company/flowConstraint/modify", parmas, expend);
    },
    getConstraintDel(parmas, expend) { // 约束规则删除
        return send("GET", "/api/company/flowConstraint/del/" + parmas.content.id, parmas, expend);
    },
    /**
     * 约束规则操作
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getProcessList(parmas, expend) { // 查询约束规则列表
        return send("GET", "/api/company/site/processLine/find", parmas, expend);
    },
    postProcessAdd(parmas, expend) { // 约束规则添加
        return send("POST", "/api/company/site/processLine/create", parmas, expend);
    },
    postProcessEdit(parmas, expend) { // 约束规则更新
        return send("POST", "/api/company/site/processLine/modify", parmas, expend);
    },
    getProcesstDel(parmas, expend) { // 约束规则删除
        return send("GET", "/api/company/site/processLine/del", parmas, expend);
    },
    /**
     *  PI数据库
     */
    getPIList(parmas, expend) { // 查询
        return send("GET", "/api/company/pi/find", parmas, expend);
    },
    postPIAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/pi/create", parmas, expend);
    },
    postPIEdit(parmas, expend) { // 编辑
        return send("POST", "/api/company/pi/modify", parmas, expend);
    },
    getPIDel(parmas, expend) { // 删除
        return send("POST", "/api/company/pi/del", parmas, expend);
    },
    getPIType(parmas, expend) { // 分类
        return send("POST", "/api/company/pi/type", parmas, expend);
    },
    getPIUnit(parmas, expend) { // 单元
        return send("POST", "/api/company/pi/unit", parmas, expend);
    },
    getPIDataType(parmas, expend) { // 数据类型
        return send("POST", "/api/company/pi/data/type", parmas, expend);
    },
    /**
     *  通知/提醒配置
     */
    getNoticeList(parmas, expend) { // 查询
        return send("GET", "/api/company/notice/config/find", parmas, expend);
    },
    postNoticeAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/notice/config/create", parmas, expend);
    },
    postNoticeEdit(parmas, expend) { // 编辑
        return send("POST", "/api/company/notice/config/modify", parmas, expend);
    },
    getNoticeDel(parmas, expend) { // 删除
        return send("GET", "/api/company/notice/config/del/" + parmas.content.id, {}, expend);
    },
    getNoticeType(parmas, expend) { // 分类
        return send("GET", "/api/company/notice/config/type", parmas, expend);
    },
    getNoticeTime(parmas, expend) { // 时间类型
        return send("GET", "/api/company/notice/config/time", parmas, expend);
    },
    getNoticeMethod(parmas, expend) { //通知方法
        return send("GET", "/api/company/notice/config/method", parmas, expend);
    },
    /**
     * HomeMap 统计信息
     */
    getHomeMapCount(parmas, expend) { // COUNT,3个数
        return send("GET", "/api/company/site/count", parmas, expend);
    },
    modifyPassword(parmas, expend) {
        return send("POST", "/api/company/user/password", parmas, expend);
    },
    getScreenCountD(parmas, expend) {
        return send("GET", "/api/park/rtu/screen", parmas, expend);
    },
    // 获取总排放量
    getAggregationLog(parmas, expend) {
        return send("GET", "/api/company/data/aggregationLog/all", parmas, expend);
    },
    // 气象数据
    getQxLog(parmas, expend) {
        return send("GET", "/api/park/qxlog/query", parmas, expend);
    }, 
    /**
    * 活性炭操作
    * @param {*} parmas 参数
    * @param {*} expend 拓展(uuid)
    */
   getActivatedCharcoalList(parmas, expend) { // 查询活性炭列表
       return send("GET", "/api/company/activatedCharcoal/find", parmas, expend);
   },
   postActivatedCharcoalAdd(parmas, expend) { // 活性炭添加
       return send("POST", "/api/company/activatedCharcoal/create", parmas, expend);
   },
   postActivatedCharcoalEdit(parmas, expend) { // 活性炭更新
       return send("POST", "/api/company/activatedCharcoal/modify", parmas, expend);
   },
   getActivatedCharcoalDel(parmas, expend) { // 活性炭删除
       return send("GET", "/api/company/activatedCharcoal/del", parmas, expend);
   },
      /**
     *  报警器
     */
      getAlarmList(parmas, expend) { // 查询
        return send("GET", "/api/company/alarm/find", parmas, expend);
    },
    postAlarmAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/alarm/create", parmas, expend);
    },
    postAlarmEdit(parmas, expend) { // 编辑
        return send("POST", "/api/company/alarm/modify", parmas, expend);
    },
    getAlarmDel(parmas, expend) { // 删除
        return send("GET", "/api/company/alarm/del", parmas, expend);
    },
}